<template>
  <div class="crud">
    <the-crud :title="title" :store="store" :columns="columns" :search="search" :filters="filters" :masive-creation-columns="masiveCreationColumns" :can-delete="isAdmin" :can-edit="isAdmin||isManager" :initQueryParams="params" :can-create="isAdmin||isManager" :hidden-query-params="{ ['organization.id']: organizationId}"></the-crud>
  </div>
</template>

<script>
import TheCrud from '@/components/crud/TheCrud'
import { mapGetters } from 'vuex';
export default {
  components : {
    TheCrud
  },
  data() {
    return {
      title : this.$t('configuration.extensions.title'),
      store : 'extensions',
      search : ['name'],
      columns : [
        { index : 'id', label : '#id', sortable : true, width: '100' },
        { index : 'name', label : this.$t("configuration.extensions.name") },
        { index : 'extension',label : this.$t("configuration.extensions.number") },
        { index : 'secret', label : this.$t("configuration.extensions.password") },
        { index : 'used', label : this.$t("configuration.extensions.used"), type : 'boolean'},
      ],
      filters : [
        {
          type : 'text',
          index : 'extension',
          label : 'Numero',
          options : ['contains']
        },
        {
          type : 'boolean',
          index : 'used',
          label : this.$t("configuration.extensions.used"),
          booleanType : 'string'
        }
      ],
      params: {
        groups: 'crud'
      }
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager']),
    masiveCreationColumns(){
      if(this.isManager){
        return []
      }
      return [
        { 
          title : 'Name', 
          description : this.$t("masive-creation.extensions.Name"),
          type : 'string',
          example : 'John Doe'
        },
        { 
          title : 'Extension', 
          description : this.$t("masive-creation.extensions.Extension"),
          type : 'number',
          example : '500'
        },
        { 
          title : 'Secret', 
          description : this.$t("masive-creation.extensions.Secret"),
          type : 'string',
          example : 'Q1t5w2r4e3%'
        },
        { 
          title : 'Organization',
          description : this.$t("masive-creation.extensions.Organizatio"),
          type : 'number',
          example : '1'
        }
      ]
    },
    organizationId() {
      return this.$store.getters["contactMe/getOrganizationId"];
    },
  }
}
</script>

<style>

</style>